import React, { forwardRef } from 'react';
import GraphicEditorHeader from './Panels/GraphicEditorHeader/GraphicEditorHeader';
import GraphicProperties from './Panels/GraphicPropertiesSidebar/GraphicPropertiesSidebar';
import LayersPanel from './Panels/LayersSidebar/GraphicLayersPanel';
import GraphicEditorTooltip from './components/GraphicEditorTooltip/GraphicEditorTooltip';
import FontsPanel from '../fontsEditor/FontsEditor';
import ProductDataPanel from './GraphicProductDataPanel';
import ControlsPanel from './components/ControlsPanel';
import ProjectProperties from './components/ProjectProperties/ProjectProperties';
import { scaleImage } from './services/ScaleService';
import { appBackendApi } from '../../app/appBackendApi';

const HEADER_TOP = 75;
const LAYER_DIFF = 320;
const MAX_DEPTH = 3;
const KONVA_STYLES = {
  width: '100%',
  position: 'absolute',
  top: HEADER_TOP,
  left: LAYER_DIFF,
  height: 'calc(100% - 4rem)',
  float: 'left',
  margin: 0,
  borderTopRightRadius: '10px',
  borderBottomRightRadius: '10px',
  backgroundColor: 'white',
};

const GraphicEditorLayout = forwardRef(function GraphicEditorLayout(
  {
    sidebarWidth,
    stage,
    selectedGroup,
    designName,
    refreshProperties,
    setDesignName,
    isProductDataPanelOpen,
    isLayersPanelOpen,
    isFontsPanelOpen,
    isProductPropertiesOpen,
    toggleLayersPanel,
    toggleFontsPanel,
    toggleProductPropertiesPanel,
    elementOps,
    saveHistory,
    history,
    handleHistoryUndo,
    handleHistoryRedo,
    exit,
    saveDesign,
    handleCanvasOnOff,
    closeOpenProductData,
    onDraggingElementFinish,
    scaleTextWithAttachedUpdate,
    handleCloseProperties,
    uploadImage,
    deleteImage,
    uploadFont,
    deleteFont,
    selectFromLayout,
    addTextWithFont,
    onDesignPropertiesChanged,
    handleDragOver,
    handleZoomIn,
    handleZoomOut,
    toPrevProduct,
    toNextProduct,
  },
  layerRef,
) {
  return (
    <>
      <GraphicEditorHeader
        exit={exit}
        addLine={elementOps.addLine}
        addRect={elementOps.addRect}
        addStar={elementOps.addStar}
        addText={elementOps.addText}
        addImage={elementOps.addImage}
        addPolygon={elementOps.addPolygon}
        addEllipse={elementOps.addEllipse}
        saveDesign={saveDesign}
        canvasOnOff={handleCanvasOnOff}
        setDesignName={setDesignName}
        onLayersClick={toggleLayersPanel}
        onProductDataClick={closeOpenProductData}
      />
      <div style={{ height: '100%', backgroundColor: '#fcfcfc' }}>
        {isProductDataPanelOpen && (
          <ProductDataPanel
            onDraggingElementFinish={onDraggingElementFinish}
            onClose={closeOpenProductData}
          />
        )}
        {selectedGroup && (
          <GraphicProperties
            scaleText={scaleTextWithAttachedUpdate}
            scaleImage={scaleImage}
            onCloseProperties={handleCloseProperties}
            uploadFile={uploadImage}
            deleteImage={deleteImage}
            fonts={appBackendApi.fonts}
            uploadFont={uploadFont}
          />
        )}
        {isLayersPanelOpen && stage && (
          <LayersPanel
            ref={layerRef}
            maxDepth={MAX_DEPTH}
            destroyGroup={elementOps.destroyGroup}
            onSelectField={selectFromLayout}
            onClose={toggleLayersPanel}
            onCopyElement={elementOps.copyElement}
            onDeleteElement={elementOps.deleteElement}
            onChangeName={refreshProperties}
            saveHistory={saveHistory}
            hideElement={elementOps.hideElement}
          />
        )}
        {isFontsPanelOpen && (
          <FontsPanel
            onClose={toggleFontsPanel}
            uploadFont={appBackendApi.uploadFont}
            deleteFont={deleteFont}
            fonts={appBackendApi.user.fonts}
            onFontClick={addTextWithFont}
          />
        )}
        {isProductPropertiesOpen && (
          <ProjectProperties
            setProperties={onDesignPropertiesChanged}
            close={toggleProductPropertiesPanel}
          />
        )}
        <div id="konva_container" style={KONVA_STYLES} onDragOver={handleDragOver} />
        <GraphicEditorTooltip
          createGroup={elementOps.createGroup}
          destroyGroup={elementOps.destroyGroup}
          copyElement={elementOps.copyElement}
          deleteElement={elementOps.deleteElement}
        />
        <ControlsPanel
          sidebarWidth={sidebarWidth}
          onPrevProduct={toPrevProduct}
          onNextProduct={toNextProduct}
          onZoomIn={handleZoomIn}
          onZoomOut={handleZoomOut}
          history={history}
          onHistoryUndo={handleHistoryUndo}
          onHistoryRedo={handleHistoryRedo}
        />
      </div>
    </>
  );
});

export default GraphicEditorLayout;
